import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const Messenger = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.4831 0C6.03371 0 0 5.60946 0 12.5368C0 16.4905 1.95506 20.0048 5.02247 22.3027L5.08989 26.6956C5.08989 26.9322 5.35955 27.0673 5.5618 26.9659L9.77528 24.6005C10.9551 24.9046 12.2022 25.0736 13.5169 25.0736C20.9663 25.0736 27 19.4641 27 12.5368C27 5.60946 20.8989 0 13.4831 0ZM14.4607 16.6256L11.5955 13.6181C11.427 13.4492 11.1573 13.4154 10.9551 13.5168L5.89888 16.2539C5.69663 16.3553 5.52809 16.1187 5.66292 15.9498L11.6292 9.5969C11.7978 9.42794 12.1011 9.42794 12.2697 9.5969L15.1348 12.672C15.3034 12.8409 15.573 12.9085 15.7753 12.7733L20.7303 10.07C20.9326 9.96861 21.1011 10.2052 20.9663 10.3741L15.1011 16.6256C14.9326 16.7946 14.6292 16.7946 14.4607 16.6256Z"
        fill="white"
      />
    </SvgIcon>
  );
};
